export enum DatatableColumnWidth {
  default = 210,
  xl = 360,
  large = 160,
  medium = 135,
  small = 110,
  tiny = 45,
  easternDateTime = 180,
}
